import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@/environments/environment';

export interface PostAuthLoginRequest {
  username: string;
  password: string;
}

export interface PostAuthLoginResponse {
  title: string;
  detail: string;
  data: {
    accessToken: string;
    expiresAt: string;
    mqttAccessToken: string;
    mqttExpiresAt: string;
    refreshToken: string;
    refreshTokenExpiresAt: string;
    user: {
      uuid: string;
      username: string;
      name: string;
    };
  };
}

export interface PostAuthLogoutResponse {
  title: string;
  detail: string;
}

export interface GetAuthProfileResponse {
  title: string;
  detail: string;
  data: {
    uuid: string;
    username: string;
    name: string;
    email: string;
    role: {
      roleId: number;
      roleName: string;
      permissions: {
        functionName: string;
        canView: boolean;
        canDetail: boolean;
        canCreate: boolean;
        canEdit: boolean;
        canDelete: boolean;
        canViewReport: boolean;
        canDownload: boolean;
      }[];
    };
    spaces: {
      id: number;
      name: string;
    }[];
  };
}

export interface PostAuthRefreshTokenRequest {
  refreshToken: string;
}

export interface PostAuthRefreshTokenResponse {
  title: string;
  detail: string;
  data: {
    accessToken: string;
    expiresAt: string;
    mqttAccessToken: string;
    mqttExpiresAt: string;
    refreshToken: string;
    refreshTokenExpiresAt: string;
    user: {
      // uuid: string;
      username: string;
      name: string;
    };
  };
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly http = inject(HttpClient);

  readonly baseUrl = signal(environment.api.baseUrl).asReadonly();

  apiPostAuthLogin(request: PostAuthLoginRequest) {
    return this.http.post<PostAuthLoginResponse>(
      `${this.baseUrl()}/api/v1/auth/login`,
      request,
    );
  }

  apiPostAuthLogout() {
    return this.http.post<PostAuthLogoutResponse>(
      `${this.baseUrl()}/api/v1/auth/logout`,
      null,
    );
  }

  apiGetAuthProfile() {
    return this.http.get<GetAuthProfileResponse>(
      `${this.baseUrl()}/api/v1/auth/profile`,
    );
  }

  apiPostAuthRefreshToken(request: PostAuthRefreshTokenRequest) {
    return this.http.post<PostAuthRefreshTokenResponse>(
      `${this.baseUrl()}/api/v1/auth/refresh-token`,
      request,
    );
  }
}
